import React, { useState } from "react";
import { Checkbox, Table } from "@opendate-app/setlist";

import { useMailkickSubscriptionIndexContext } from "./MailkickSubscriptionIndexContainer";
import { toastError } from "../../../shared/toastHelper";

const LISTS = [
  { key: "MARKETING_EMAIL", header: "Email" },
  { key: "MARKETING_SMS", header: "SMS" },
];

const SubscriptionCheckbox = ({ list, venueOwnership, subscribed, toggleSubscription }) => {
  const [checked, setChecked] = useState(subscribed);

  const toggle = () => {
    const previous = checked;
    setChecked(!previous);
    toggleSubscription(`${list.key}-${venueOwnership.id}`, previous).catch(() => {
      setChecked(previous);
      toastError("Could not update the subscription, please try again");
    });
  };

  return (
    <Checkbox
      aria-label={`${list.header} for ${venueOwnership.venueable.name}`}
      checked={checked}
      onChange={toggle}
    />
  );
};

const MailkickSubscriptionIndex = () => {
  const {
    mailkickSubscriptionsByVenueOwnership,
    venueOwnerships,
    toggleSubscription,
  } = useMailkickSubscriptionIndexContext();

  const rows = [...venueOwnerships].sort((a, b) => (a.venueable?.name || "").localeCompare(b.venueable?.name || ""));

  const columns = [
    { key: "venue", header: "Venue", primary: true, render: (venueOwnership) => venueOwnership.venueable.name },
    ...LISTS.map((list) => ({
      key: list.key,
      header: list.header,
      align: "center",
      width: 72,
      render: (venueOwnership) => (
        <SubscriptionCheckbox
          list={list}
          venueOwnership={venueOwnership}
          subscribed={!!mailkickSubscriptionsByVenueOwnership[venueOwnership.id]?.[list.key]}
          toggleSubscription={toggleSubscription}
        />
      ),
    })),
  ];

  return (
    <div>
      <p style={{ fontSize: 16, fontWeight: 600, color: "var(--sl-text-primary)", margin: "0 0 8px" }}>Subscriptions</p>
      <Table columns={columns} data={rows} getRowKey={(venueOwnership) => venueOwnership.id} />
    </div>
  );
};

export default MailkickSubscriptionIndex;
